module.exports = __webpack_public_path__ + "static/media/snackbar_v2_info.f2b6aad2.svg";